import Hammer from 'hammerjs';
import { RefObject, useEffect, useRef } from 'react';

export type UseHammerEventCallback = (
  event?: HammerInput,
  elementRef?: RefObject<HTMLDivElement>,
) => void;

export const useHammer = (eventName: 'swipe', callback: UseHammerEventCallback, enable = true) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const hammerInstance = useRef<any>(null);

  useEffect(() => {
    if (elementRef.current && !hammerInstance.current) {
      hammerInstance.current = new Hammer(elementRef.current);
      hammerInstance.current.on(eventName, (event?: HammerInput) => callback(event, elementRef));
      hammerInstance.current.get(eventName).set({ enable: true });
    }

    return () => {
      hammerInstance.current.off(eventName, (event?: HammerInput) => callback(event, elementRef));
    };
  }, [callback, eventName]);

  useEffect(() => {
    if (hammerInstance.current) {
      hammerInstance.current.get(eventName).set({ enable });
    }
  }, [enable, eventName]);

  return { elementRef, hammerInstance };
};
